import React from 'react';
import { useTranslation } from 'react-i18next';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import Hidden from '@wix/da-ds/pkg/Icons/Hidden';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useDeviationMatureFilter } from '../../../../../../utils/hooks/useDeviationMatureFilter';
import { BlockReasons } from '../../../../../../Moderation/redux/types';
/** placeholder for various block reasons, eg mature, antisocial, etc
 * TODO: if one day we properly redo mature and such, create more specific
 * components for each block reason
 */
var BlockedMiddleContent = function (_a) {
    var thumbHeight = _a.thumbHeight, className = _a.className, deviation = _a.deviation;
    var t = useTranslation().t;
    var displayReason = useDeviationMatureFilter(deviation).displayReason;
    var isMatureBlock = [
        BlockReasons.MatureAge,
        BlockReasons.MatureFilter,
        BlockReasons.MatureLoggedOut,
        BlockReasons.StrictMatureAge,
    ].includes(displayReason);
    var isUnreasonablySmall = thumbHeight && (isMatureBlock ? thumbHeight < 180 : thumbHeight < 150);
    if (isUnreasonablySmall) {
        return (React.createElement(HoverOnly, { reverseHidden: true },
            React.createElement(ThumbMiddleContent, { icon: React.createElement(Hidden, { size: IconSize.LARGE, disableDefaultColors: true }), className: className })));
    }
    return (React.createElement(ThumbMiddleContent, { title: isMatureBlock
            ? t('deviation.overlay.blocked.mature')
            : t('deviation.overlay.blocked'), className: className }));
};
BlockedMiddleContent.displayName = 'BlockedMiddleContent';
export default BlockedMiddleContent;
//# sourceMappingURL=BlockedMiddleContent.js.map